import allPurposeBottle from '../assets/all_purpose.png';
import peachRubBottle from '../assets/peach_rub.png';
import garlicButterBottle from '../assets/garlic_butter.png';
import spiceAllPurposeBottle from '../assets/spicy_all_purpose.png';

// Label images for cart thumbnails
import allPurposeLabel from '../assets/all_purpose_label.webp';
import peachRubLabel from '../assets/peach_rub_label.webp';
import garlicButterLabel from '../assets/garlic_butter_label.webp';
import spiceAllPurposeLabel from '../assets/spice_all_purpose_label.webp';

// Recipe images
import kajunShrimpSausageSkillet from '../assets/Kajun_Shrimp_Sausage_Skillet.png';
import kajunRoastedChickenThighs from '../assets/Kajun_Roasted_Chicken_Thighs.png';
import peachGingerGlazedSalmon from '../assets/peach_ginger_glazed_salmon.png';
import kajunButterShrimpPasta from '../assets/kajun_butter_shrimp_pasta.png';

export const products = [
  {
    id: 'all-purpose',
    name: 'All Purpose Seasoning',
    description: "Kajun Kitchen's All Purpose Seasoning & Rub delivers a bold, balanced blend of smoky paprika, Himalayan pink salt, and savory spices. Perfect for meats, vegetables, soups, and sauces, it adds depth and complexity to any dish. Versatile and flavorful, this signature seasoning transforms everyday meals into gourmet experiences.",
    price: 12.99,
    image: allPurposeBottle,
    labelImage: allPurposeLabel,
    category: 'seasoning',
    inStock: true,
    featured: true,
    nutritionFacts: {
      servingSize: '1/4 tsp (1.1g)',
      servingsPerContainer: 160,
      calories: 0,
      nutrients: [
        { name: 'Total Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Saturated Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Trans Fat', amount: '0g', dailyValue: '' },
        { name: 'Cholesterol', amount: '0mg', dailyValue: '0%' },
        { name: 'Sodium', amount: '340mg', dailyValue: '15%' },
        { name: 'Total Carbohydrate', amount: '0g', dailyValue: '0%' },
        { name: 'Dietary Fiber', amount: '0g', dailyValue: '0%' },
        { name: 'Total Sugars', amount: '0g', dailyValue: '0%' },
        { name: 'Added Sugars', amount: '0g', dailyValue: '0%' },
        { name: 'Protein', amount: '0g', dailyValue: '0%' }
      ]
    },
    ingredients: 'Himalayan pink salt, granulated garlic & onion, red pepper, black pepper, smoked paprika, and other herbs and spices.',
    allergens: 'WHEAT, MILK, EGGS, AND SOY.',
    featuredRecipe: {
      title: 'Kajun Shrimp & Sausage Skillet',
      image: kajunShrimpSausageSkillet,
      description: 'Classic Kajun flavors shine through'
    }
  },
  {
    id: 'peach-rub',
    name: 'Peach Rub Seasoning',
    description: "Kajun Kitchen's Peach Rub blends sweet, smoky, and spicy notes for a truly unique flavor experience. Crafted with ripe peaches, brown sugar, Himalayan sea salt, and a touch of ginger and pepper, it brings balance and depth to any dish. Perfect for grilling, roasting, or seasoning seafood and veggies, this versatile rub turns everyday meals into gourmet creations.",
    price: 13.99,
    image: peachRubBottle,
    labelImage: peachRubLabel,
    category: 'seasoning',
    inStock: true,
    featured: false,
    nutritionFacts: {
      servingSize: '0.25 tsp (1.1g)',
      servingsPerContainer: 218,
      calories: 60,
      nutrients: [
        { name: 'Total Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Saturated Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Trans Fat', amount: '0g', dailyValue: '' },
        { name: 'Sodium', amount: '100mg', dailyValue: '4%' },
        { name: 'Total Carbohydrate', amount: '25g', dailyValue: '9%' },
        { name: 'Dietary Fiber', amount: '0g', dailyValue: '0%' },
        { name: 'Total Sugars', amount: '40g', dailyValue: '—' },
        { name: 'Added Sugars', amount: '10g', dailyValue: '20%' },
        { name: 'Protein', amount: '3g', dailyValue: '6%' }
      ]
    },
    ingredients: 'Peaches, light brown sugar, cane sugar, pink Himalayan sea salt, ginger, granulated garlic & onion, red pepper, black pepper, and other herbs and spices.',
    allergens: 'WHEAT, MILK, EGGS, AND SOY.',
    featuredRecipe: {
      title: 'Peach-Ginger Glazed Salmon',
      image: peachGingerGlazedSalmon,
      description: 'Elegant dinner perfection'
    }
  },
  {
    id: 'garlic-butter',
    name: 'Garlic Butter Seasoning',
    description: "Kajun Kitchen's Garlic Butter Seasoning delivers a rich, savory blend that elevates any dish. Featuring creamy butter flavor, aromatic garlic, and Himalayan pink salt, it adds depth and balance to your favorite recipes. Perfect for meats, vegetables, and more, this versatile seasoning brings gourmet taste to everyday meals.",
    price: 12.99,
    image: garlicButterBottle,
    labelImage: garlicButterLabel,
    category: 'seasoning',
    inStock: true,
    featured: false,
    nutritionFacts: {
      servingSize: '1/4 tsp (1.1g)',
      servingsPerContainer: 160,
      calories: 0,
      nutrients: [
        { name: 'Total Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Saturated Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Trans Fat', amount: '0g', dailyValue: '' },
        { name: 'Cholesterol', amount: '0mg', dailyValue: '0%' },
        { name: 'Sodium', amount: '340mg', dailyValue: '15%' },
        { name: 'Total Carbohydrate', amount: '0g', dailyValue: '0%' },
        { name: 'Dietary Fiber', amount: '0g', dailyValue: '0%' },
        { name: 'Total Sugars', amount: '0g', dailyValue: '0%' },
        { name: 'Added Sugars', amount: '0g', dailyValue: '0%' },
        { name: 'Protein', amount: '0g', dailyValue: '0%' }
      ]
    },
    ingredients: 'Butter flavoring, Himalayan pink salt, granulated garlic, other herbs and spices.',
    allergens: 'WHEAT, MILK, EGGS, AND SOY.',
    featuredRecipe: {
      title: 'Kajun Butter Shrimp Pasta',
      image: kajunButterShrimpPasta,
      description: 'Creamy comfort food at its finest'
    }
  },
  {
    id: 'spice-all-purpose',
    name: 'Spice All Purpose Seasoning',
    description: "Kajun Kitchen's Spicy All Purpose Seasoning & Rub brings bold, authentic flavor to every dish. Crafted with Himalayan pink salt, smoky paprika, and a balanced blend of peppers, garlic, and onion, it delivers a perfect mix of heat and depth. Versatile and vibrant, this seasoning transforms meats, seafood, veggies, and even popcorn into gourmet experiences.",
    price: 13.99,
    image: spiceAllPurposeBottle,
    labelImage: spiceAllPurposeLabel,
    category: 'seasoning',
    inStock: true,
    featured: false,
    nutritionFacts: {
      servingSize: '1/4 tsp (1.1g)',
      servingsPerContainer: 160,
      calories: 0,
      nutrients: [
        { name: 'Total Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Saturated Fat', amount: '0g', dailyValue: '0%' },
        { name: 'Trans Fat', amount: '0g', dailyValue: '' },
        { name: 'Cholesterol', amount: '0mg', dailyValue: '0%' },
        { name: 'Sodium', amount: '340mg', dailyValue: '15%' },
        { name: 'Total Carbohydrate', amount: '0g', dailyValue: '0%' },
        { name: 'Dietary Fiber', amount: '0g', dailyValue: '0%' },
        { name: 'Total Sugars', amount: '0g', dailyValue: '0%' },
        { name: 'Added Sugars', amount: '0g', dailyValue: '0%' },
        { name: 'Protein', amount: '0g', dailyValue: '0%' }
      ]
    },
    ingredients: 'Himalayan pink salt, red pepper, smoked paprika, granulated garlic & onion, black pepper, and other herbs and spices.',
    allergens: 'WHEAT, MILK, EGGS, AND SOY.',
    featuredRecipe: {
      title: 'Kajun Roasted Chicken Thighs',
      image: kajunRoastedChickenThighs,
      description: 'Crispy skin, bold flavor'
    }
  }
];
